import React, { useMemo } from "react";
import { Box, Slider, Typography } from "@material-ui/core";

// Lista de TODOS los días entre minYmd y maxYmd (ambos "YYYY-MM-DD",
// inclusive) — el slider se mueve sobre el ÍNDICE de este arreglo en vez de
// hacer aritmética con timestamps, así se evita cualquier problema de huso
// horario al convertir ida y vuelta.
function buildDayList(minYmd, maxYmd) {
  if (!minYmd || !maxYmd) return [];
  const [y1, m1, d1] = minYmd.split("-").map(Number);
  const [y2, m2, d2] = maxYmd.split("-").map(Number);
  let cursor = new Date(y1, m1 - 1, d1);
  const fin = new Date(y2, m2 - 1, d2);
  const dias = [];
  while (cursor <= fin) {
    const yyyy = cursor.getFullYear();
    const mm = String(cursor.getMonth() + 1).padStart(2, "0");
    const dd = String(cursor.getDate()).padStart(2, "0");
    dias.push(`${yyyy}-${mm}-${dd}`);
    cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1);
  }
  return dias;
}

function labelCorto(ymd) {
  if (!ymd) return "";
  const [yyyy, mm, dd] = ymd.split("-");
  return `${dd}/${mm}/${yyyy}`;
}

// Slider de rango (dos manijas, mismo componente Slider de MUI que ya usa
// DashboardExtraInputs.jsx) para elegir fecha de inicio/fin — reemplaza los
// inputs de texto de fecha. dateFrom/dateTo van como "YYYY-MM-DD" ("" =
// extremo del rango disponible). Requiere minDate/maxDate (el rango
// disponible completo) para saber sobre qué días moverse.
export default function DashboardDateRangePicker({
  minDate,
  maxDate,
  dateFrom,
  dateTo,
  onChangeDateFrom,
  onChangeDateTo,
}) {
  const dias = useMemo(() => buildDayList(minDate, maxDate), [minDate, maxDate]);

  if (dias.length < 2) {
    return null;
  }

  const idxDesde = dateFrom ? dias.indexOf(dateFrom) : 0;
  const idxHasta = dateTo ? dias.indexOf(dateTo) : dias.length - 1;
  const value = [
    idxDesde === -1 ? 0 : idxDesde,
    idxHasta === -1 ? dias.length - 1 : idxHasta,
  ];

  function handleChange(event, nuevoValor) {
    onChangeDateFrom(dias[nuevoValor[0]]);
    onChangeDateTo(dias[nuevoValor[1]]);
  }

  return (
    <Box style={{ padding: "0 12px" }}>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {labelCorto(dias[value[0]])} — {labelCorto(dias[value[1]])}
      </Typography>
      <Slider
        value={value}
        onChange={handleChange}
        min={0}
        max={dias.length - 1}
        valueLabelDisplay="off"
      />
    </Box>
  );
}
